import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var EncodeURIComponentPipe = (function () {
    function EncodeURIComponentPipe() {
    }
    EncodeURIComponentPipe.prototype.transform = function (input) {
        if (!isString(input)) {
            return input;
        }
        return encodeURIComponent(input);
    };
    return EncodeURIComponentPipe;
}());
export { EncodeURIComponentPipe };
EncodeURIComponentPipe.decorators = [
    { type: Pipe, args: [{
                name: 'encodeURIComponent'
            },] },
];
/** @nocollapse */
EncodeURIComponentPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=encode-uri-component.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/encode-uri-component.pipe.js
// module id = 276
// module chunks = 103